module.exports = __webpack_public_path__ + "25f988064caecc3e7a653d8918617567.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/surrey.svg
// module id = 48
// module chunks = 0